import { use, useEffect, useState } from "react";
import styles from "./AccountTickets.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { getFile, getUserStream } from "services/api";
import Spinner from "./Spinner";

const AccountStreams = () => {

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleGetTickets = async () => {
    setLoading(true);
    const response = await getUserStream();
    if (response.success) {
      console.log("Streams récupérés avec succès", response.data);
      setTickets(response.data);
    } else {
      setError("Erreur lors de la récupération des stearms");
      console.error("Erreur lors de la récupération des stearms", response.error);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (!tickets.length && !error) {
      handleGetTickets();
    }
  }, []);

  return (
    <div className={styles.AccountTickets}>
      <div className={styles.HeaderContent}>

        <div className={styles.Title}>Liste de vos streams</div>

        <div className={styles.ButtonContainer}>
          <Link to="/programme/stream">
            <Button>
              Accéder à la page stream
            </Button>
          </Link>
        </div>
      </div>

      {loading && (
        <Spinner />
      )}

      <ul className={styles.TicketsList}>
        {tickets.map((ticket, index) => (

          <li key={index}>
            <div className={`${styles.TicketItem} ${ticket.statut === "Annulée" ? styles.Cancelled : ticket.statut === "Validé" ? styles.Active : ""}`}>
              <div className={`${styles.TicketDetails} ${styles.WithImage}`}>
                <div className={styles.TicketImage}>
                  <img src={ticket.image} alt={ticket.spectacle_title} />
                </div>
                <div>
                  <div className={styles.TicketNumber}>{ticket.spectacle_title}</div >
                  <p>{ticket.date_formatted}</p>
                  <p className={styles.TicketLocation}>{ticket.lieu}</p>
                </div>
              </div>
              <div className={styles.TicketActions}>
                <div className={styles.Status}>
                  <span>{ticket.status}</span>
                </div>
                <div className={styles.Invoice}>
                  {ticket.invoiceURL && ticket.invoiceURL !== '#' && <Link to={ticket.invoiceURL} target="_blank">
                    Télécharger tous les billets ({ticket.tickets ? ticket.tickets.length : 0})
                  </Link>}
                </div>
              </div>
            </div>
            {ticket.codes && ticket.codes.length > 0 &&
              <ul className={styles.SubTicketsList}>
                {ticket.codes.map((code) => (
                  <li key={code.code_id}>
                    <div className={`${styles.TicketItem} ${code.status === "Annulée" ? styles.Cancelled : ""}`}>
                      <div className={styles.TicketDetails}>
                        <div className={styles.TicketNumber}>Code de stream: {code.code}</div >
                        <p className={styles.TicketLocation}>Commande n°{code.commande_id}</p>
                        <p>Commande réalisée le : {code.date_commande_formatted}</p>
                      </div>
                      <div className={styles.TicketActions}>
                        <Link target="_blank" to={`/programme/stream/${code.code}`}>
                          <Button>
                            Accéder au stream
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>}
          </li>
        ))}
        {tickets.length === 0 && !loading && !error && (
          <li className={styles.Title}>Aucun billet trouvé.</li>
        )}
      </ul>
    </div >
  );
}

export default AccountStreams;





































